import { Card, Text, Button } from "@merge-api/merge-javascript-shared";
import { ChevronRight } from "lucide-react";
import React from "react";
import clsx from "clsx";

export interface FeatureCardProps {
  icon: React.ReactNode;
  title: string | React.ReactNode;
  children: React.ReactNode;
  docsPath?: string;
  className?: string;
}

const FeatureCard: React.FC<FeatureCardProps> = ({
  icon,
  title,
  children,
  docsPath,
  className,
}) => (
  <Card
    variant="none"
    className={clsx("w-full bg-teal-0 p-4 mb-6 flex flex-col gap-y-3", className)}
  >
    <div className="flex flex-row items-center gap-x-3 flex-nowrap">
      {icon}
      <Text variant="h5">{title}</Text>
    </div>
    {children}
    {docsPath && (
      <Button
        size="sm"
        rightIcon={<ChevronRight size={12} />}
        onClick={() => window.open(docsPath, "_blank")}
      >
        View docs
      </Button>
    )}
  </Card>
);

export default FeatureCard;
